import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import {
    FaPlus, FaEdit, FaTrash, FaSearch,
    FaStar, FaArrowRight, FaArrowLeft,
    FaSortAmountUp, FaSortAmountDown, FaSpinner,
    FaListOl, FaFont
} from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Gestion_avis_client = ({ titre }) => {
    useAuth();

    // États
    const [questions, setQuestions] = useState([]);
    const [filteredQuestions, setFilteredQuestions] = useState([]);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingList, setIsLoadingList] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: 'reference', direction: 'ascending' });

    // État pour le formulaire
    const [formData, setFormData] = useState({
        reference: '',
        question: '',
        type_question: 'echelle',
        statut: 'actif'
    });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState(["AVIS_CLIENT"]);

    // Effets
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Avis Client";
            fetchQuestions();
        }
    }, [user_id]);

    useEffect(() => {
        // Filtrer les questions basées sur la recherche
        if (searchTerm.trim() === '') {
            setFilteredQuestions(questions);
            setTotalItems(questions.length);
        } else {
            const filtered = questions.filter(q =>
                q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
                q.reference.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredQuestions(filtered);
            setTotalItems(filtered.length);
        }
        setCurrentPage(1); // Retour à la première page lors d'une nouvelle recherche
    }, [searchTerm, questions]);

    // Trier les questions
    useEffect(() => {
        const sortedQuestions = [...filteredQuestions].sort((a, b) => {
            if (sortConfig.direction === 'ascending') {
                return a[sortConfig.key] > b[sortConfig.key] ? 1 : -1;
            } else {
                return a[sortConfig.key] < b[sortConfig.key] ? 1 : -1;
            }
        });
        setFilteredQuestions(sortedQuestions);
    }, [sortConfig]);

    // Fonctions API
    const fetchQuestions = async () => {
        setIsLoadingList(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-questions-avis-client/`);
            if (response.data.success) {
                setQuestions(response.data.questions);
                setFilteredQuestions(response.data.questions);
                setTotalItems(response.data.total);
            } else {
                showAlert("Erreur lors du chargement des questions", "danger");
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert("Erreur lors du chargement des questions", "danger");
        } finally {
            setIsLoadingList(false);
        }
    };

    const handleAddQuestion = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_HOTE}/ajouter-question-avis-client/${user_id}/`,
                formData
            );

            if (response.data.success) {
                showAlert("Question ajoutée avec succès !");
                fetchQuestions(); // Rafraîchir la liste
                handleCloseModals();
            } else {
                showAlert(response.data.error || "Erreur lors de l'ajout", "danger");
            }
        } catch (error) {
            console.error('Erreur:', error);
            if (error.response?.data?.error) {
                showAlert(error.response.data.error, "danger");
            } else {
                showAlert("Erreur lors de l'ajout", "danger");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleUpdateQuestion = async () => {
        if (!selectedQuestion) return;

        setIsLoading(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_HOTE}/modifier-question-avis-client/${selectedQuestion.id}/${user_id}/`,
                formData
            );

            if (response.data.success) {
                showAlert("Question modifiée avec succès !");
                fetchQuestions(); // Rafraîchir la liste
                handleCloseModals();
                setSelectedQuestion(null);
            } else {
                showAlert(response.data.error || "Erreur lors de la modification", "danger");
            }
        } catch (error) {
            console.error('Erreur:', error);
            if (error.response?.data?.error) {
                showAlert(error.response.data.error, "danger");
            } else {
                showAlert("Erreur lors de la modification", "danger");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteQuestion = async () => {
        if (!selectedQuestion) return;

        setIsLoading(true);
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_HOTE}/supprimer-question-avis-client/${selectedQuestion.id}/${user_id}/`
            );

            if (response.data.success) {
                showAlert("Question supprimée avec succès !", "success");
                fetchQuestions(); // Rafraîchir la liste
                handleCloseModals();
                setSelectedQuestion(null);
            } else {
                showAlert(response.data.error || "Erreur lors de la suppression", "danger");
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert(error.response?.data?.error || "Erreur lors de la suppression", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    // Fonctions utilitaires
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: '', type: '' }), 5000);
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    const handleRowClick = (question) => {
        setSelectedQuestion(question.id === selectedQuestion?.id ? null : question);
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Gestion des modals
    const handleShowAddModal = () => {
        setIsEditMode(false);
        const nextNumber = questions.length + 1;
        setFormData({
            reference: `CLI-${nextNumber.toString().padStart(3, '0')}`,
            question: '',
            type_question: 'echelle',
            statut: 'actif'
        });
        setShowAddEditModal(true);
    };

    const handleShowEditModal = () => {
        if (!selectedQuestion) {
            showAlert("Veuillez sélectionner une question à modifier", "danger");
            return;
        }

        setIsEditMode(true);
        setFormData({
            reference: selectedQuestion.reference,
            question: selectedQuestion.question,
            type_question: selectedQuestion.type_question || 'echelle',
            statut: selectedQuestion.statut
        });
        setShowAddEditModal(true);
    };

    const handleShowDeleteModal = () => {
        if (!selectedQuestion) {
            showAlert("Veuillez sélectionner une question à supprimer", "danger");
            return;
        }
        setShowDeleteModal(true);
    };

    const handleCloseModals = () => {
        setShowAddEditModal(false);
        setShowDeleteModal(false);
        setFormData({
            reference: '',
            question: '',
            type_question: 'echelle',
            statut: 'actif'
        });
    };

    // Gestion du formulaire
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        if (isEditMode) {
            handleUpdateQuestion();
        } else {
            handleAddQuestion();
        }
    };

    // Pagination
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredQuestions.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Fonction pour afficher les options d'une question
    const renderQuestionOptions = (question) => {
        if (question.type_question === 'ouverte') {
            return <span className="badge badge-info">Question ouverte</span>;
        }

        // Question à échelle - toujours 1 à 5
        return (
            <div className="options-preview mt-1">
                <div className="text-muted small mb-1">
                    <FaListOl className="mr-1" /> Échelle : 5 à 1
                </div>
                <div className="text-muted small"><strong>5</strong> (Très satisfait / Excellent)</div>
                <div className="text-muted small"><strong>4</strong> (Satisfait)</div>
                <div className="text-muted small"><strong>3</strong> (Neutre)</div>
                <div className="text-muted small"><strong>2</strong> (Insatisfait)</div>
                <div className="text-muted small"><strong>1</strong> (Très insatisfait / Médiocre)</div>
            </div>
        );
    };

    // Vérification des accès
    if (!accesGroupe.includes("AVIS_CLIENT")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className="">
                                <h2 className='d-flex align-items-center'>
                                    <FaStar size={25} className='mr-2' />
                                    Avis Client
                                </h2>
                                <small>Gestion des questions pour les enquêtes de satisfaction client.</small>
                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/liste-avis-client`}> Avis Client</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {/* Alertes */}
                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2 mt-2`}>
                            <div>{alert.message}</div>
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="mt-2">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            {/* En-tête avec boutons d'action */}
                            <div className="d-flex flex-column justify-content-between flex-md-row mt-3 mt-md-0">
                                <h5>Liste des Questions Client</h5>
                                <div className="d-flex mb-3 mt-md-0" style={{ gap: '10px' }}>
                                    <button
                                        onClick={handleShowAddModal}
                                        className="btn btn-success d-flex align-items-center justify-content-center ms-2 mt-1"
                                    >
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                    </button>

                                    <button
                                        onClick={handleShowEditModal}
                                        disabled={!selectedQuestion}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedQuestion ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">Modifier</span>
                                    </button>

                                    <button
                                        onClick={handleShowDeleteModal}
                                        disabled={!selectedQuestion}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedQuestion ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline ml-2">Supprimer</span>
                                    </button>
                                </div>
                            </div>

                            {/* Tableau des questions */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">

                                            {/* Barre de recherche et pagination */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Rechercher par référence ou question..."
                                                    style={{ maxWidth: "250px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                />
                                            </div>

                                            {isLoadingList ? (
                                                <div className="text-center py-5">
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <div className="spiner-example">
                                                            <div className="sk-spinner sk-spinner-wave">
                                                                <div className="sk-rect1 mr-1"></div>
                                                                <div className="sk-rect2 mr-1"></div>
                                                                <div className="sk-rect3 mr-1"></div>
                                                                <div className="sk-rect4 mr-1"></div>
                                                                <div className="sk-rect5"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                        <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                            <thead>
                                                                <tr>
                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('reference')}>
                                                                        Référence
                                                                        {sortConfig.key === 'reference' &&
                                                                            (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)
                                                                        }
                                                                    </th>
                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('question')}>
                                                                        Question
                                                                        {sortConfig.key === 'question' &&
                                                                            (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)
                                                                        }
                                                                    </th>
                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('type_question')}>
                                                                        Type
                                                                        {sortConfig.key === 'type_question' &&
                                                                            (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)
                                                                        }
                                                                    </th>
                                                                    <th className='text-secondary text-wrap' onClick={() => handleSort('statut')}>
                                                                        Statut
                                                                        {sortConfig.key === 'statut' &&
                                                                            (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)
                                                                        }
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentItems.length > 0 ? (
                                                                    currentItems.map((question) => (
                                                                        <tr
                                                                            key={question.id}
                                                                            className={`bg-white ${selectedQuestion && selectedQuestion.id === question.id ? 'bg-success text-white' : ''}`}
                                                                            onClick={() => handleRowClick(question)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            <td>
                                                                                <strong>{question.reference}</strong>
                                                                            </td>
                                                                            <td>
                                                                                <div>{question.question}</div>
                                                                                {/* {renderQuestionOptions(question)} */}
                                                                            </td>
                                                                            <td>
                                                                                {question.type_question === 'echelle' ? (
                                                                                    <span className="badge badge-primary">
                                                                                        Échelle (1 à 5)
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="badge badge-info">
                                                                                        Ouverte
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <span className={`badge ${question.statut === 'actif' ? 'badge-success' : 'badge-secondary'}`}>
                                                                                    {question.statut === 'actif' ? 'Actif' : 'Inactif'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="4" className="text-center py-4">
                                                                            Aucune question trouvée.
                                                                            {/* {searchTerm && (
                                                                                <div className="mt-2">
                                                                                    <button
                                                                                        className="btn btn-sm btn-link"
                                                                                        onClick={() => setSearchTerm('')}
                                                                                    >
                                                                                        Réinitialiser la recherche
                                                                                    </button>
                                                                                </div>
                                                                            )} */}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    {/* Pagination */}
                                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                                        <div className="dataTables_info" role="status" aria-live="polite">
                                                            {currentItems.length === 0
                                                                ? "Aucun élément à afficher"
                                                                : `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)
                                                                } sur ${totalItems}`}
                                                        </div>
                                                        <div>
                                                            <button
                                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                                className="btn btn-light mx-1"
                                                                disabled={currentPage === 1}
                                                            >
                                                                <FaArrowLeft />
                                                            </button>

                                                            {(() => {
                                                                const pagesToShow = 5;
                                                                let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                                let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                                if (endPage - startPage < pagesToShow - 1) {
                                                                    startPage = Math.max(1, endPage - pagesToShow + 1);
                                                                }

                                                                const pageButtons = [];

                                                                for (let i = startPage; i <= endPage; i++) {
                                                                    pageButtons.push(
                                                                        <button
                                                                            key={i}
                                                                            onClick={() => setCurrentPage(i)}
                                                                            className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                        >
                                                                            {i}
                                                                        </button>
                                                                    );
                                                                }

                                                                return pageButtons;
                                                            })()}

                                                            <button
                                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                                className="btn btn-light mx-1"
                                                                disabled={currentPage === totalPages}
                                                            >
                                                                <FaArrowRight />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modal Ajouter/Modifier - SIMPLIFIÉ */}
                            <Modal show={showAddEditModal} onHide={handleCloseModals}>
                                <Modal.Header>
                                    <Modal.Title>
                                        {isEditMode ? 'Modifier la Question' : 'Ajouter une Nouvelle Question'}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Référence <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="reference"
                                                value={formData.reference}
                                                onChange={handleFormChange}
                                                placeholder="Ex: CLI-001"
                                                required
                                            />
                                            <Form.Text className="text-muted">
                                                Identifiant unique de la question
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Question <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                name="question"
                                                value={formData.question}
                                                onChange={handleFormChange}
                                                placeholder="Saisissez la question à poser aux clients..."
                                                required
                                            />
                                            <Form.Text className="text-muted">
                                                La question telle qu'elle apparaîtra dans le formulaire client
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Type de question <span className='text-danger'>*</span></Form.Label>
                                            <Form.Select
                                                name="type_question"
                                                className='custom-select'
                                                value={formData.type_question}
                                                onChange={handleFormChange}
                                            >
                                                <option value="echelle">Question à échelle (1-5)</option>
                                                <option value="ouverte">Question ouverte (réponse libre)</option>
                                            </Form.Select>
                                            {/* <Form.Text className="text-muted">
                                                Échelle : 5 = Très satisfait/Excellent, 4 = Satisfait, 3 = Neutre, 2 = Insatisfait, 1 = Très insatisfait/Médiocre
                                            </Form.Text> */}
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Statut</Form.Label>
                                            <Form.Select
                                                name="statut"
                                                className='custom-select'
                                                value={formData.statut}
                                                onChange={handleFormChange}
                                            >
                                                <option value="actif">Actif (visible pour les clients)</option>
                                                <option value="inactif">Inactif (masqué des clients)</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModals}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleSubmit}
                                        disabled={!formData.reference.trim() || !formData.question.trim() || isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <FaSpinner className="fa-spin me-2" />
                                                {isEditMode ? 'Modification...' : 'Ajout...'}
                                            </>
                                        ) : (
                                            isEditMode ? 'Modifier' : 'Ajouter'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal Suppression */}
                            <Modal show={showDeleteModal} onHide={handleCloseModals}>
                                <Modal.Header>
                                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Êtes-vous sûr de vouloir supprimer cette question ?</p>
                                    {selectedQuestion && (
                                        <div className="alert alert-warning">
                                            <strong>Référence :</strong> {selectedQuestion.reference}<br />
                                            <strong>Question :</strong> {selectedQuestion.question}<br />
                                            <strong>Type :</strong> {selectedQuestion.type_question === 'echelle' ? 'Question à échelle' : 'Question ouverte'}
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModals}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleDeleteQuestion}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <FaSpinner className="fa-spin me-2" />
                                                Suppression...
                                            </>
                                        ) : (
                                            'Supprimer'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gestion_avis_client;